import request from "@/utils/request";

export function handleListApi(data) {
    return request({
        url: "/admin/faq_type",
        method: "get",
        params: data
    });
}

export function handleCreateStoreApi(data) {
    if (data.id) {
        return request({
            url: "/admin/faq_type/" + data.id,
            method: "put",
            data
        });
    } else {
        return request({
            url: "/admin/faq_type",
            method: "post",
            data
        });
    }
}

export function handleDeleteApi(data) {
    return request({
        url: "/admin/faq_type/" + data.id,
        method: "delete"
    });
}

